import { Component, OnInit, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { LocalStorageService } from "angular-2-local-storage";
import { environment } from "../../../../environments/environment";
import { SortType } from "../../../enum/jubili/company-manage/sort-type";
import { AuthorizedApps } from "../../../enum/shared/authorized-apps.enum";
import { SortCompanyModel } from "../../../model/jubili/company-manage/company-sort";
import { GetUserModel } from "../../../model/jubili/user-manage/get-users";
import { AuthenticationService } from "../../../service/api/auth/auth.service";
import { PolicyService } from "../../../service/policy.service";
import { UserListIndexModel, UserlistModel } from "./../../../model/builk/user-manager/get-users";
import { UserManagerService } from "./../../../service/api/builk/user-manager.service";
import { formatDate } from "@angular/common";
import { AccountStatusType } from "../../../enum/builk/user-manager/account-status-type";

@Component({
  selector: "bo-builk-user-manager",
  templateUrl: "./user-manager.component.html",
  styleUrls: ["./user-manager.component.scss"]
})

export class UserManagerComponent implements OnInit {

  constructor(
    private readonly router: Router,
    private readonly localStorageService: LocalStorageService,
    private readonly userManageService: UserManagerService,
    private readonly AuthService: AuthenticationService,
    private readonly policyService: PolicyService
  ) { }
  userList: Array<UserlistModel> = new Array<UserlistModel>();
  userIndex: UserListIndexModel = new UserListIndexModel();
  getUser: GetUserModel = new GetUserModel();
  // using for page list (default)
  page: number = 1;
  lastPage: number = 1;
  limit: number = 50;
  countAll: number = 0;
  // using for search
  searchUserName: string = "";
  searchCompanyName: string = "";
  searchPhoneNumber: string = "";
  searchProvince: string = "";
  searchUserInactiveStatus: number;
  searchReferralCode: string[] = [];
  referralCodeList: string[] = [];
  // using for sort (default)
  sortCol: string = "createdate";
  sortType: number = SortType.DESC;
  countryList = new Array<string>();
  periodDate: Array<Date> = [];
  isAbleExport: boolean = true;
  isExporting: boolean = false;
  isLoading: boolean = false;

  accountStatusType: Array<{ value: any, label: string }> = [
    { value: AccountStatusType.Active, label: "Active" },
    { value: AccountStatusType.Inactive, label: "Inactive" },
    { value: AccountStatusType.Unknown, label: "Unknown" },
  ];

  ngOnInit(): void {
    const currentYear = new Date().getFullYear();
    this.periodDate = [new Date(currentYear, 0, 1), new Date(currentYear, 11, 31)];
    this.onDateChange();
    
    this.getReferralCodeList();
    this.setDataUserlist();
  }

  getReferralCodeList(): void {
    this.userManageService.getReferralCodeSelector().subscribe(res => {
      this.referralCodeList = res;
    });
  }

  setDataUserlist(): void {
    this.isLoading = true;
    this.getUser.page = ((this.page - 1) * 50) + 1;
    this.getUser.limit = this.limit;
    this.getUser.sortcol = this.sortCol;
    this.getUser.sorttype = this.sortType;
    // ต้องเลือกตามประเทศ

    // Start of Get country list from user policy
    this.policyService.getUserPolicy(environment.firebaseConfig.policyCollection,
      "userEmail",
      this.localStorageService.get<string>("userEmail"))
      .subscribe(response => {
        if (response.length > 0) {
          const authorizedApp = response[0].authorizedApps.find(f => f.appName === AuthorizedApps.Builk);
          if (authorizedApp !== undefined) {
            this.countryList = authorizedApp.country;
            this.getUser.countrysearch = this.countryList.join(",");
          }
        } // End of Get country list from user policy
        this.getUser.email = this.localStorageService.get<string>("userEmail");

        this.userManageService.getAllUserBackOffice(this.getUser)
          .subscribe(
            Response => {
              this.userIndex = Response;
              this.userList = this.userIndex.data; // set data to show list
              this.userList = this.jobFunctionListEng();
              this.countAll = this.userIndex.count;
              this.lastPage = Math.ceil((this.userIndex.count) / (this.limit));
              this.isLoading = false;

              // ปิดไว้ก่อนเดะกลับมาแก้เป็นยิงไป Check CognitoV3
              // this.userList.forEach(element => {
              //   this.AuthService.checkRegister(element.userEmail)
              //     .subscribe(
              //       Result => {
              //         element.isRegister = Result !== 1 ? true : false;
              //       }
              //     );
              // });
            },
            err => {
              // unauthorized refresh token
              console.log("unauth");
              if (err.status === 401) {
                this.AuthService.refreshSessionToken()
                  .subscribe(
                    Response => {
                      // Update session
                      this.localStorageService.set("accessToken", Response.authenticationResult.accessToken);

                      this.localStorageService.set("expiresTime", (Date.now() / 1000) + Response.authenticationResult.expiresIn);
                    }
                  );
                this.isLoading = false;
                this.setDataUserlist();
              } else {
                this.isLoading = false;
                this.router.navigate(["/home"]);
              }
            }
          );
      });
  }

  initFilter() {
    this.getUser.usernamesearch = this.searchUserName;
    this.getUser.companynamesearch = this.searchCompanyName;
    this.getUser.userInactiveStatus = this.searchUserInactiveStatus;
    this.getUser.referralCode = this.searchReferralCode;
  }

  searchUser(): void {
    this.initFilter();
    this.page = 1;
    this.setDataUserlist();
  }
  // searchCompanyname(): void {
  //     this.getUser.companynamesearch = this.searchcompanyname;
  //     this.setDataUserlist();
  // }
  // sort user list
  sortList(event: SortCompanyModel): void {
    this.sortCol = event.sortCol;
    this.sortType = event.sortType;
    this.setDataUserlist();
  }
  backPage(): void {
    if (this.page > 1) {
      this.page--;
      this.setDataUserlist();
    }
  }

  nextPage(): void {
    if (this.page < this.lastPage) {
      this.page++;
      this.setDataUserlist();
    }
  }

  goTofirstPage(): void {
    if (this.page > 1) {
      this.page = 1;
      this.setDataUserlist();
    }
  }

  goTolastPage(): void {
    if (this.page < this.lastPage) {
      this.page = this.lastPage;
      this.setDataUserlist();
    }
  }

  jobFunctionListThai(): Array<UserlistModel> {
    for (const data of this.userList) {
      switch (data.roles) {
        case "1":
          data.roles = "บริหาร";
          break;
        case "2":
          data.roles = "ก่อสร้าง/หน้างาน";
          break;
        case "3":
          data.roles = "ประมาณราคา/ถอดแบบ";
          break;
        case "4":
          data.roles = "ออกแบบ/เขียนแบบ";
          break;
        case "5":
          data.roles = "จัดซื้อ";
          break;
        case "6":
          data.roles = "ขาย/การตลาด";
          break;
        case "7":
          data.roles = "บัญชี/การเงิน";
          break;
        case "8":
          data.roles = "ธุรการ";
          break;
        case "9":
          data.roles = "บุคคล";
          break;
        case "10":
          data.roles = "อื่น ๆ";
          break;
        default:
          data.roles = "";
          break;
      }
    }

    return this.userList;
  }

  jobFunctionListEng(): Array<UserlistModel> {
    for (const data of this.userList) {
      switch (data.roles) {
        case "1":
          data.roles = "Management";
          break;
        case "2":
          data.roles = "Site Engineer, Site Architect, Foreman";
          break;
        case "3":
          data.roles = "Quantity Surveyor,Estimator";
          break;
        case "4":
          data.roles = "Designer";
          break;
        case "5":
          data.roles = "Purchasing";
          break;
        case "6":
          data.roles = "Sales, Marketing";
          break;
        case "7":
          data.roles = "Accounting, Finance";
          break;
        case "8":
          data.roles = "Administrator";
          break;
        case "9":
          data.roles = "Personnel";
          break;
        case "10":
          data.roles = "Other";
          break;
        default:
          data.roles = "";
          break;
      }
    }

    return this.userList;
  }

  jobFunctionListOther(): Array<UserlistModel> {
    for (const data of this.userList) {
      switch (data.roles) {
        case "1":
          data.roles = "Management";
          break;
        case "2":
          data.roles = "Insinyur Lapangan, Arsitek Lapangan, Mandor";
          break;
        case "3":
          data.roles = "Inspektur Kuantitas, Pengukur";
          break;
        case "4":
          data.roles = "Perancang";
          break;
        case "5":
          data.roles = "Pembelian";
          break;
        case "6":
          data.roles = "Sales, Marketing";
          break;
        case "7":
          data.roles = "Accounting, Finance";
          break;
        case "8":
          data.roles = "Administrator";
          break;
        case "9":
          data.roles = "Personalia";
          break;
        case "10":
          data.roles = "Lain-Lain";
          break;
        default:
          data.roles = "";
          break;
      }
    }

    return this.userList;
  }

  reload(event: boolean): void {
    this.searchUser();
  }

  exportUserListBuilk() {
    // if (this.periodDate.length == 0) {
    //   console.log("On invalid")
    //   this.isAbleExport = false;
    //   return;
    // }
    this.initFilter();
    this.isAbleExport = true;
    this.isExporting = true;
    this.userManageService.exportUserListBuilk(this.getUser).subscribe((res) => {
      let url = window.URL.createObjectURL(res);
      let a = document.createElement('a');
      document.body.appendChild(a);
      a.setAttribute('style', 'display: none');
      a.href = url;
      a.download = "user_manager_report_" + formatDate(Date(), 'ddMMyyyy', 'en-US');
      a.click();
      window.URL.revokeObjectURL(url);
      this.isExporting = false;
      a.remove();
    }, (err) => {
      this.isExporting = false;
      alert("Error Message : " + err.message)
    }, () => {
      this.isExporting = false;
    });
  }

  onDateChange(): void {
    if (this.periodDate && this.periodDate.length > 0) {
      this.isAbleExport = true;
      this.getUser.startDate = this.periodDate[0];
      this.getUser.endDate = this.periodDate[1];
    } else {
      this.getUser.startDate = undefined;
      this.getUser.endDate = undefined;
    }
  }

  resetDateRange(): void {
    this.periodDate = [];
    this.getUser.startDate = undefined;
    this.getUser.endDate = undefined;
  }

  onFilterChange() {
    this.getUser.userInactiveStatus = this.searchUserInactiveStatus;
    this.getUser.referralCode = this.searchReferralCode;
  }
}
